import React from 'react';
import { Box, Chip } from '@mui/material';

const colorMap = {
  default: { bg: null, fg: null },
  info: { bg: 'rgba(59, 130, 246, 0.15)', fg: '#3b82f6' },
  warning: { bg: 'rgba(245, 158, 11, 0.15)', fg: '#f59e0b' },
  success: { bg: 'rgba(34, 197, 94, 0.15)', fg: '#22c55e' },
  error: { bg: 'rgba(239, 68, 68, 0.15)', fg: '#ef4444' },
};

const WorkspaceStatusBar = ({ counters, colors }) => {
  if (!counters || counters.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 1.5,
        py: 0.5,
        borderTop: `1px solid ${colors.border}`,
        bgcolor: colors.surface,
      }}
    >
      {counters.map((counter, i) => {
        const c = colorMap[counter.color] || colorMap.default;
        return (
          <Chip
            key={i}
            label={`${counter.label}: ${counter.count ?? '–'}`}
            title={counter.count == null ? 'Shown when the whole list is loaded' : undefined}
            size="small"
            sx={{
              borderRadius: 0,
              fontSize: '0.7rem',
              height: 22,
              bgcolor: c.bg || colors.surfaceElevated,
              color: c.fg || colors.textSecondary,
            }}
          />
        );
      })}
    </Box>
  );
};

export default WorkspaceStatusBar;
